<template>
  <IconSvgBase :class="$style.path" :view-width="20" :view-height="20">
    <path
      fill-rule="evenodd"
      clip-rule="evenodd"
      d="M9.98616 6.10194L5.30533 10.7828L5.08533 13.2461L7.56616 13.0203L12.2328 8.3486L9.98616 6.10194ZM14.972 5.60694L12.7262 3.36194L11.1028 4.98527L13.3487 7.23194L14.972 5.60694ZM4.24283 14.9961C4.217 14.9986 4.192 14.9994 4.167 14.9994C3.947 14.9994 3.7345 14.9128 3.57783 14.7553C3.40283 14.5803 3.3145 14.3369 3.337 14.0911L3.65283 10.6153C3.68783 10.2344 3.85616 9.87527 4.127 9.60444L11.6237 2.10694C12.2087 1.52027 13.2703 1.54944 13.887 2.16527L16.1687 4.44694H16.1695C16.8078 5.0861 16.8328 6.10027 16.2262 6.7086L8.72866 14.2061C8.45783 14.4778 8.0995 14.6453 7.71783 14.6803L4.24283 14.9961ZM4.16683 16.6662H15.8335C16.2918 16.6662 16.6668 17.0412 16.6668 17.4995C16.6668 17.9579 16.2918 18.3329 15.8335 18.3329H4.16683C3.7085 18.3329 3.3335 17.9579 3.3335 17.4995C3.3335 17.0412 3.7085 16.6662 4.16683 16.6662Z"
    />
  </IconSvgBase>
</template>

<script setup lang="ts">
import IconSvgBase from '@/components/icons/IconSvgBase.vue'
</script>

<style lang="scss" module>
.path {
  width: 1em;
  height: 1em;
}
</style>
